module.exports = __webpack_public_path__ + "static/pro-active-support-0e04c84c722e443e6f2070a78da3e97a.svg";